import React, { useState, useEffect } from 'react'
import { PaginationControl } from "react-bootstrap-pagination-control";
import { Link } from 'react-router-dom'
import { Get, Delete } from '../../web_api/api'
import 'react-photo-view/dist/react-photo-view.css';
import { FaEdit, FaTrash } from "react-icons/fa";
import '../../branch/branch.css'

export default function PromoList() {
    const [bannerList, setBannerList] = useState([])
    const [dataCount, setDataCount] = useState("")
    const [page, setPage] = useState(1)

    const handleDelete = async (event) => {
        await Delete('/banner-photo/', event)
        const result = bannerList.filter(item => item._id !== event)
        setBannerList(result)
    }

    useEffect(() => {
        const getBlogs = async () => {
            const res = await Get('banner-photos')
            setBannerList(res.data)
            setDataCount(res.data.length)
        }
        getBlogs()
    }, [])

    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <span className='current'>Banner List</span>
            </div>

            <div className='branch-card'>
                <div className='branch-card-header'>
                    <span />
                    <Link to='/banner-create' className='branch-btn branch-btn-primary'>
                        + Add
                    </Link>
                </div>

                <div className='branch-card-body' style={{ padding: 0 }}>
                    <div className='branch-table-wrapper'>
                        <table className='branch-table'>
                            <thead>
                                <tr>
                                    <th>Image</th>
                                    <th>Page</th>
                                    <th>Description</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bannerList.slice((page - 1) * 10, page * 10).map((item) => (
                                    <tr key={item._id}>
                                        <td><img src={item.imgUrl} width='250px' height='120px' /></td>
                                        <td>{item.page}</td>
                                        <td>{item.description}</td>
                                        <td>
                                            <Link to={'/banner-update/' + item._id}>
                                                <button type='button' className='btn btn-sm btn-warning mr-2'><FaEdit /> Update</button>
                                            </Link>
                                            <button onClick={() => handleDelete(item._id)} className='btn btn-sm btn-danger'><FaTrash /> Delete</button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='branch-pagination'>
                        <PaginationControl
                            page={page}
                            between={4}
                            total={dataCount}
                            limit={10}
                            changePage={(page) => { setPage(page) }}
                            ellipsis={1}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
